// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const commonErrorApiCodeCtf = {
  ctfAuthMemberAccessRequired: "The current SSO identity has no matching CTF member",
  ctfAuthMemberInactive: "The matching CTF member is not active",
  ctfMemberNotFound: "CTF member {member_id} was not found",
  ctfMemberUserIdRequired: "The CTF member request is missing user_id",
  ctfMemberUsernameRequired: "The CTF member request is missing a username",
  ctfMemberDuplicateUserId: "The CTF member request contains duplicate user_id {user_id}",
  ctfMemberAlreadyExists: "The CTF member already exists: {user_ids}",
  ctfMemberInvalidRoles: "The CTF member roles are invalid",
  ctfPlatformApplicationNotFound: "The CTF platform application {app_key} was not found",
  ctfPlatformDataContractInvalid:
    "The CTF platform data contract is invalid for {field_name}: {reason}",
  ctfBusinessEventInboxRetryLater: "The CTF event is waiting for a later retry",
  ctfBusinessEventUnexpectedRetryableFailure:
    "The CTF event encountered an unexpected retryable failure",
} as const;
